import { Component, OnInit } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-user-management",
	templateUrl: "./user-management.component.html",
	styleUrls: ["./user-management.component.scss"]
})
export class UserManagementComponent implements OnInit {
	public brand = BrandVars;

	organizations: APIResults.Organization[];
	addorganization = {
		name: ""
	};
	adduser = {
		organization: <APIResults.Organization | undefined>undefined,
		email: "",
		password: "",
		role: <string | undefined>"user"
	};
	errormessage = "";

	constructor(private api: ApiService) { }

	ngOnInit() {
		this.UpdateOrganizations();
	}

	AddOrganization() {
		if (this.addorganization.name) {
			this.errormessage = "";
			this.api.AddOrganization(this.addorganization.name).then(() => {
				this.addorganization.name = "";
				this.UpdateOrganizations();
			}).catch(() => {
				this.errormessage = "Couldn't add organization";
			});
		}
	}

	UpdateOrganizations() {
		this.errormessage = "";
		this.api.GetOrganizations().then(orgs => {
			this.organizations = orgs;
		}).catch(() => {
			this.errormessage = "Couldn't get organizations";
		});
	}

	AddUser() {
		if (this.adduser.organization && this.adduser.email && this.adduser.password && this.adduser.role) {
			this.errormessage = "";
			this.api.AddUser(this.adduser.organization.organization_id, this.adduser.email, this.adduser.password, this.adduser.role).then(() => {
				this.adduser.organization = undefined;
				this.adduser.email = "";
				this.adduser.password = "";
				this.adduser.role = undefined;
			}).catch(() => {
				this.errormessage = "Couldn't add user";
			});
		}
	}

}
